var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59229 10.5456C2.59229 11.4637 2.79343 12.1656 3.05634 12.5912C3.19644 12.8336 3.39818 13.0345 3.64108 13.1736C3.88398 13.3127 4.15937 13.3851 4.43928 13.3833C5.11532 13.3833 5.73376 13.2164 6.92558 11.5672C7.88037 10.246 9.00543 8.39566 9.76325 7.2272L11.0452 5.25753C11.9357 3.88961 12.9648 2.36895 14.1483 1.33487C15.1123 0.496922 16.153 0.029541 17.2004 0.029541C18.959 0.029541 20.634 1.0486 21.916 2.95985C23.319 5.05305 24.0025 7.68958 24.0025 10.4104C24.0025 12.0279 23.6837 13.2164 23.1412 14.1553C22.6179 15.0633 21.593 15.9706 19.8745 15.9706V13.3833C21.3459 13.3833 21.7107 12.0312 21.7107 10.4838C21.7107 8.27881 21.1966 5.83174 20.064 4.08323C19.2603 2.84301 18.2187 2.08518 17.0728 2.08518C15.8334 2.08518 14.836 3.01994 13.7151 4.68666C13.1192 5.57218 12.5074 6.65132 11.8206 7.86902L11.0644 9.20439C9.54542 11.8977 9.16066 12.5111 8.40117 13.5235C7.07247 15.3029 5.93574 15.9706 4.43928 15.9706C2.66407 15.9706 1.54152 15.2019 0.850466 14.0435C0.278759 13.0995 0 11.861 0 10.4496L2.59229 10.5456Z",
    fill: "#0081FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04396 3.14263C3.23244 1.31066 4.94756 0.029541 6.91473 0.029541C8.05397 0.029541 9.18654 0.363384 10.3692 1.33236C11.6628 2.38814 13.0399 4.12663 14.7617 6.99184L15.3785 8.02008C16.8674 10.5005 17.7154 11.7758 18.2103 12.3784C18.848 13.1513 19.2953 13.3799 19.8745 13.3799C21.3459 13.3799 21.7107 12.0279 21.7107 10.4805L23.9975 10.4087C23.9975 12.0262 23.6787 13.2147 23.1362 14.1536C22.6179 15.0633 21.593 15.9706 19.8745 15.9706C18.8062 15.9706 17.8598 15.7385 16.8132 14.7512C16.0086 13.9934 15.068 12.6472 14.3444 11.437L12.192 7.84148C11.112 6.03705 10.1213 4.69166 9.54792 4.08574C8.93031 3.42723 8.13827 2.63602 6.873 2.63602C5.84894 2.63602 4.97927 3.35462 4.2515 4.4538L2.04396 3.14263Z",
    fill: "url(#paint0_linear_5_8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.873 2.63602C5.84894 2.63602 4.97927 3.35462 4.25149 4.4538C3.22242 6.00701 2.59229 8.32054 2.59229 10.5456C2.59229 11.4637 2.79343 12.1656 3.05634 12.5912L0.846293 14.0435C0.278759 13.0995 0 11.861 0 10.4496C0 7.88321 0.70441 5.20829 2.04396 3.14263C3.23244 1.31066 4.94756 0.029541 6.91473 0.029541L6.873 2.63602Z",
    fill: "url(#paint1_linear_5_8)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_8",
    x1: 5.20295,
    y1: 7.58692,
    x2: 21.7282,
    y2: 8.42153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_8",
    x1: 3.45695,
    y1: 11.6306,
    x2: 3.45695,
    y2: 5.53796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.941,
    fill: "white",
    transform: "translate(0 0.029541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaIcon);
export default __webpack_public_path__ + "static/media/meta-icon.9138b7ebba1755ade18fc57a3e7f1a80.svg";
export { ForwardRef as ReactComponent };